/* PabDer — header search: click magnifying glass to open an inline dropdown
   search box instead of redirecting straight to the /search page. */
(function(){
  function init(){
    var trigger=document.getElementById('searchTrigger');
    var drop=document.getElementById('searchDrop');
    var scrim=document.getElementById('searchDropScrim');
    var input=document.getElementById('searchDropInput');
    var close=document.getElementById('searchDropClose');
    if(!trigger||!drop||!input) return;

    function open(){
      drop.classList.add('open');
      trigger.setAttribute('aria-expanded','true');
      if(scrim) scrim.classList.add('open');
      setTimeout(function(){ input.focus(); },10);
    }
    function shut(){
      drop.classList.remove('open');
      trigger.setAttribute('aria-expanded','false');
      if(scrim) scrim.classList.remove('open');
    }
    function toggle(){
      if(drop.classList.contains('open')) shut(); else open();
    }

    trigger.addEventListener('click',function(e){e.stopPropagation();toggle();});
    if(close) close.addEventListener('click',function(e){e.stopPropagation();shut();});
    if(scrim) scrim.addEventListener('click',shut);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drop.classList.contains('open'))shut();});
    document.addEventListener('click',function(e){
      if(drop.classList.contains('open') && !drop.contains(e.target) && e.target!==trigger) shut();
    });
  }

  /* Most products in this catalog don't have the Shopify "SKU" field filled in —
     the product code (AA4881, CS9101, TW5115C…) lives at the front of the title
     instead (sometimes after a brand-name word, e.g. "Pabder AA4881 …"). Pull
     that code out with a regex so we have something real to sort by. */
  function extractCode(text){
    if(!text) return '';
    var m = text.match(/[A-Za-z]{2,3}\d{3,6}[A-Za-z]?/);
    return m ? m[0].toUpperCase() : '';
  }

  /* Search results: re-order the product cards by product code in alphabetical +
     numerical sequence (e.g. CS1151, CS1823, CS1824…) instead of Shopify's
     default relevance ranking, so a partial code query like "CS1" lists every
     matching product in a predictable, scannable order. Products with no
     recognisable code are pushed to the end, keeping their original order. */
  function sortSearchGrid(){
    var grid = document.querySelector('.search-grid');
    if(!grid) return;
    var cards = Array.prototype.slice.call(grid.children).filter(function(el){
      return el.classList && el.classList.contains('pd-prod');
    });
    if(cards.length < 2) return;
    cards.forEach(function(card){
      if(card.dataset.sortCode) return;
      var sku = (card.getAttribute('data-sku') || '').trim();
      var nameEl = card.querySelector('.pd-prod__name');
      var code = sku || extractCode(nameEl ? nameEl.textContent : '');
      card.dataset.sortCode = code;
    });
    cards.sort(function(a,b){
      var codeA = a.dataset.sortCode || '';
      var codeB = b.dataset.sortCode || '';
      if(!codeA && !codeB) return 0;
      if(!codeA) return 1;
      if(!codeB) return -1;
      return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  }

  function initAll(){
    init();
    sortSearchGrid();
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',initAll);
})();
